import React from 'react';
import MainSection from './MainSection';

const RecsAnalyticsWidgetsPerformance = () => <MainSection />;

export default RecsAnalyticsWidgetsPerformance;
